import React, { useState } from "react";
import { Button, Container, Modal } from "react-bootstrap";
import "./ProfileBoard.css";
import img1 from "../../../images/features/feature1.png";
import img2 from "../../../images/features/feature2.png";
import img3 from "../../../images/features/feature3.png";
import img4 from "../../../images/features/feature4.png";
import img5 from "../../../images/features/feature5.png";
import img6 from "../../../images/features/feature6.png";
import img7 from "../../../images/features/feature7.png";
import img8 from "../../../images/features/feature8.png";
import {
  BsFillCartCheckFill,
  BsFillSuitHeartFill,
  BsThreeDotsVertical,
} from "react-icons/bs";
import { FaTruckMoving,FaPercentage } from "react-icons/fa";
import { BsFillCreditCard2FrontFill } from "react-icons/bs";
import { AiFillFire,AiOutlineOrderedList } from "react-icons/ai";
import { MdLocalOffer} from "react-icons/md";
import { Link } from "react-router-dom";
import useAuth from "../../../Hooks/useAuth";
const ProfileBoard = () => {
  const {
    selectOverview,
    selectCart,
    selectWish,
    selectOrder,
    hideInfoModal,
    showInfoModal,
    showInfo,
    wish,
    order,
    cart,
    overview,
  } = useAuth();

  const [showTablesData, setShowTablesData] = useState(false);

  const tableDataHandlerClose = () => setShowTablesData(false);
  const tableDataHandler = () => setShowTablesData(true);
  const products = [
    {
      id: 1,
      productName: "Womens skirt",
      price: 12.99,
      quantity: 5,
      img: img1,
    },
    {
      id: 2,
      productName: "Mens Shirt",
      price: 7.99,
      quantity: 2,
      img: img2,
    },
    {
      id: 3,
      productName: "Kids dypar",
      price: 3.99,
      quantity: 7,
      img: img3,
    },
    {
      id: 4,
      productName: "Girls t-shirt",
      price: 12.99,
      quantity: 5,
      img: img4,
    },
    {
      id: 5,
      productName: "Boys Pant",
      price: 7.99,
      quantity: 2,
      img: img5,
    },
    {
      id: 6,
      productName: "Kids dypar",
      price: 3.99,
      quantity: 7,
      img: img6,
    },
    {
      id: 7,
      productName: "Womens skirt",
      price: 12.99,
      quantity: 5,
      img: img7,
    },
    {
      id: 8,
      productName: "Mens Shirt",
      price: 7.99,
      quantity: 2,
      img: img8,
    },
    {
      id: 9,
      productName: "Kids dypar",
      price: 3.99,
      quantity: 7,
      img: img1,
    },
    {
      id: 10,
      productName: "Girls t-shirt",
      price: 12.99,
      quantity: 5,
      img: img2,
    },
    {
      id: 11,
      productName: "Boys Pant",
      price: 7.99,
      quantity: 2,
      img: img3,
    },
    {
      id: 12,
      productName: "Kids dypar",
      price: 3.99,
      quantity: 7,
      img: img4,
    },
  ];
  return (
    <div className="section-container">
      <Modal
        className="rounded-0"
        show={showTablesData}
        onHide={tableDataHandlerClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={tableDataHandlerClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showInfo} onHide={hideInfoModal} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <div className="p-2">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Veritatis,
          qui ducimus alias tempora mollitia fugit officia saepe possimus
          impedit quos optio quibusdam tempore et architecto iusto corporis
          provident id sunt aliquid non eligendi dolores? Doloribus eum minus
          rem quisquam, repellat tempore, aperiam exercitationem maxime
          perferendis eveniet vel alias! Voluptatibus repellat eligendi iure quo
          atque provident explicabo doloremque voluptate laboriosam quia
          architecto ullam labore est tenetur delectus, ipsa facere? Sunt
          provident molestias deserunt accusantium dolorem error sequi deleniti
          iste optio officia labore a dolorum aliquam, fugiat ab praesentium
          laudantium, assumenda vel aspernatur, beatae quod iure! Ratione,
          consectetur nostrum? Magnam magni earum odio vitae recusandae eum
          debitis rem nam, aspernatur autem eaque. Nesciunt quia architecto
          minus distinctio expedita inventore voluptates nihil nulla! Reiciendis
          inventore laboriosam mollitia nobis aliquid quos ullam natus
          aspernatur corporis repellendus quis cupiditate molestias modi
          voluptas, tempora ab dolorem ducimus. Consequuntur, dolores voluptas!
          Est a quam debitis cum molestias quis ab, ex non amet esse tempore
          eaque commodi voluptatum voluptate sit facere possimus officiis velit
          accusamus, incidunt animi voluptates perferendis aliquid quae? Debitis
          fuga consectetur at accusantium soluta, adipisci, ex ab labore nemo
          perferendis exercitationem eligendi laborum recusandae, aperiam vel?
          Assumenda numquam tempora ullam excepturi rerum perspiciatis ut magni
          cum eius nulla? Vel, qui. Recusandae cum placeat nam ipsum laborum
          tenetur. Vel dolor veritatis libero, iure aliquam ea sequi architecto
          at reprehenderit, consectetur, cumque ad nulla! Dolores deserunt
          praesentium voluptatem repellat atque! Ratione soluta voluptatum omnis
          illum? Mollitia commodi totam temporibus minima. Ex in reprehenderit
          eos quasi, culpa nulla dicta eveniet dolorem, iusto cumque hic
          repellendus qui ad perferendis excepturi! Ratione similique molestiae
          totam consequuntur autem repellendus omnis odit saepe tempora quis
          rerum maxime et soluta, voluptatibus aut distinctio magni esse. Hic ad
          blanditiis fugit nobis assumenda labore nam culpa consectetur iste
          sequi. Quas animi incidunt beatae inventore nemo voluptatibus non sunt
          perspiciatis earum nesciunt, deserunt suscipit facere eligendi neque.
          Ad odit aliquid labore quaerat? Eaque eveniet iure est modi inventore
          aut aperiam pariatur, odit aliquam rerum? Quaerat, praesentium animi
          labore repellendus similique natus maxime ullam dolorum impedit itaque
          aperiam modi excepturi, dolores debitis necessitatibus odit officiis
          eaque incidunt reprehenderit cumque dolore minima. Asperiores
          veritatis itaque libero? Distinctio quidem quam voluptate, inventore
          magnam expedita deserunt veniam quaerat id veritatis itaque nobis
          labore tempora exercitationem atque assumenda obcaecati? Illo quisquam
          quae beatae odio dolorem voluptatibus. Quis placeat, quo molestias
          perferendis inventore illo, mollitia dolore, praesentium neque nulla
          laboriosam officia? Molestiae vel similique repellat aspernatur ut.
          Repudiandae sint perspiciatis minima veritatis vel aut! Eligendi,
          accusamus aspernatur reprehenderit et ipsa sequi suscipit consequatur
          omnis, placeat enim quae nulla fuga, repellendus iusto repellat qui
          ducimus molestias quia. Nisi ipsum laboriosam amet alias veniam harum?
          Qui accusamus voluptate saepe doloribus adipisci accusantium amet
          culpa voluptates ipsam, cupiditate enim eveniet fuga recusandae vero
          tempore distinctio, magni repellat exercitationem inventore architecto
          dolorum? Quaerat, maxime molestiae eius accusamus a ipsam dolore
          corporis cum enim aspernatur perferendis rem molestias velit possimus
          asperiores, aut quisquam iusto. Placeat velit maxime inventore
          officiis quidem a, consectetur atque itaque voluptate doloremque
          ratione!
        </div>
      </Modal>
      <Container>
        <div>
          <div className="profile">
            <div className="profile-image">
              <img
                src={require("../../../images/users/user4.png")}
                alt=""
                className="w-100 h-100"
              />
            </div>
            <h4 className="fw-light m-0">Mart Otto</h4>
            <p className="m-0">example@gmail.com</p>
            <div className="mt-2">
              <Button variant="light border rounded-0">Edit Profile</Button>
              <Button onClick={showInfoModal} variant="primary" className="ms-2 rounded-0">
                View Info
              </Button>
            </div>
          </div>
          <div className="profile-navigator">
            <ul className="p-0 m-0 d-flex align-items-center">
              <li>
                <button
                  className={`${overview ? "active-tab" : ""}`}
                  onClick={selectOverview}
                >
                  Overview
                </button>
              </li>
              <li>
                <button
                  className={`${cart ? "active-tab" : ""}`}
                  onClick={selectCart}
                >
                  Cart
                </button>
              </li>
              <li>
                <button
                  className={`${order ? "active-tab" : ""}`}
                  onClick={selectOrder}
                >
                  Orders
                </button>
              </li>
              <li>
                <button
                  className={`${wish ? "active-tab" : ""}`}
                  onClick={selectWish}
                >
                  Wishlishts
                </button>
              </li>
            </ul>
          </div>
          <div className="selected-section">
            <div>
              {overview && (
                <div className="overview">
                  <div>
                    <div className="mb-3">
                      <h4 className="pb-2 fw-light">Profile Board</h4>
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div
                            onClick={selectCart}
                            className="profile-card pointer"
                          >
                            <div className="position-absolute p-2 top-0 end-0">
                              <BsFillCartCheckFill className="fs-4" />
                            </div>
                            <h5 className="fw-light text-dark">Cart Items</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div
                            onClick={selectOrder}
                            className="profile-card pointer"
                          >
                            <div className="position-absolute p-2 top-0 end-0">
                              <AiOutlineOrderedList className="fs-4" />
                            </div>
                            <h5 className="fw-light text-dark">Order Items</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div
                            onClick={selectWish}
                            className="profile-card pointer"
                          >
                            <div className="position-absolute p-2 top-0 end-0">
                              <BsFillSuitHeartFill className="fs-4" />
                            </div>
                            <h5 className="fw-light text-dark">Wishlist Items</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <Link
                            to="/track"
                            className="text-decoration-none text-dark"
                          >
                            <div className="profile-card">
                              <div className="position-absolute p-2 top-0 end-0">
                                <FaTruckMoving className="fs-4" />
                              </div>
                              <h5 className="fw-light text-dark">Track Order</h5>
                              <h3>78%</h3>
                            </div>
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3">
                      <h4 className="pb-2 fw-light">Products Update</h4>
                      <div className="row">
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div className="profile-card">
                          <div className="position-absolute p-2 top-0 end-0">
                                <BsFillCreditCard2FrontFill className="fs-4 text-info" />
                              </div>
                            <h5 className="fw-light text-dark">New Arrival</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div className="profile-card">
                          <div className="position-absolute p-2 top-0 end-0">
                                <AiFillFire className="fs-4 text-warning" />
                              </div>
                            <h5 className="fw-light text-dark">Hot Products</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div className="profile-card">
                          <div className="position-absolute p-2 top-0 end-0">
                                <FaPercentage className="fs-4 text-danger" />
                              </div>
                            <h5 className="fw-light text-dark">Mega Deals</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 col-xl-3 py-2">
                          <div className="profile-card">
                          <div className="position-absolute p-2 top-0 end-0">
                                <MdLocalOffer className="fs-4 text-success" />
                              </div>
                            <h5 className="fw-light text-dark">Today's Offer</h5>
                            <h3>02</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {cart && (
                <div className="cart">
                  <div>
                    <h4 className="pb-2 fw-light">Cart Items</h4>
                    <div className="mt-3">
                      <div>
                        <div>
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="table-heading fw-bold">Name</div>
                            <div className="table-heading fw-bold lg-screen">
                              Image
                            </div>
                            <div className="table-heading fw-bold lg-screen">
                              Price
                            </div>
                            <div className="table-heading fw-bold lg-screen">
                              Quantity
                            </div>
                            <div className="table-heading fw-bold lg-screen">
                              Option
                            </div>
                            <div className="table-heading fw-bold text-end">
                              Action
                            </div>
                          </div>
                          {products.map((product, i) => (
                            <div
                              key={i}
                              className="d-flex align-items-center justify-content-between border-bottom"
                            >
                              <div className="table-heading my-1">
                                {product.productName}
                              </div>
                              <div className="table-heading my-1 lg-screen">
                                <div className="product-table-img">
                                  <img
                                    src={product.img}
                                    alt=""
                                    className="w-100 h-100"
                                  />
                                </div>
                              </div>
                              <div className="table-heading my-1 lg-screen">
                                $ {product.price}
                              </div>
                              <div className="table-heading my-1 lg-screen">
                                {product.quantity}
                              </div>
                              <Link
                                to="/checkout"
                                className="table-heading my-1 lg-screen text-decoration-none text-dark"
                              >
                                Order Now
                              </Link>
                              <div className="table-heading my-1 text-end">
                                <span className="lg-screen">Remove</span>
                                <div className="sm-screen">
                                  <BsThreeDotsVertical
                                    onClick={tableDataHandler}
                                  />
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {order && (
                <div className="order">
                  <div>
                    <h4 className="pb-2 fw-light">Order Items</h4>
                    <div className="mt-3">
                      <div className="row">
                        <div className="col-12 col-md-9 col-lg-10 col-xl-10">
                          <h4 className="fw-light">
                            No Items Found in Order list
                          </h4>
                        </div>
                        <div className="col-12 col-md-3 col-lg-2 col-xl-2 text-end">
                          <Link to="/">
                            <Button variant="light" className="border w-100">
                              Add Item
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {wish && (
                <div className="wish">
                  <div>
                    <h4 className="pb-2 fw-light">Wishlist</h4>
                    <div className="mt-3">
                      <div className="row">
                        <div className="col-12 col-md-9 col-lg-10 col-xl-10">
                          <h4 className="fw-light">
                            No Items Found in Order list
                          </h4>
                        </div>
                        <div className="col-12 col-md-3 col-lg-2 col-xl-2 text-end">
                          <Link to="/">
                            <Button variant="light" className="border w-100">
                              Add Item
                            </Button>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ProfileBoard;
